import React from "react";
import headerBg from "./assets/picOne.png"; // You can replace this with an actual calibration image
import weights from "./assets/IMG-20251215-WA0112.jpg";
import Comparators from "./assets/IMG-20251215-WA0104.jpg";
const CalibrationServices = () => {
  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Calibration Services</h1>
          <p className="intro-line">
            Ensuring measurement confidence in mass, length, volume, and temperature.
          </p>
        </div>
      </section>

      {/* === Overview Section === */}
      <section className="overview-section">
        <div className="overview-content">
          <p className="subtitle">
            Calibration is the process of checking the integrity of measurement by the determination of the relationship between the output quantity (e.g. weighing machine indicator) and the input quantity (e.g. standard weight). Calibration services are offered to manufacturing, pharmaceutical as well as construction industry in the field of mass, length, volume and temperature for measurement confidence.
          </p>
        </div>
      </section>

      {/* === Equipment Section === */}
      <section className="content-section">
        <h2 className="section-title">Calibration Equipment</h2>
        <div className="services-cards">
          <div className="service-card">
            <img src={weights} alt="Weights" />
            <h3>Weights (L)</h3>
            <p>Used for calibration of weights and balances.</p>
          </div>
          <div className="service-card">
            <img src={Comparators} alt="Mass Comparators" />
            <h3>Mass Comparators (R)</h3>
            <p>Used for calibration of weights and balances.</p>
          </div>
        </div>
      </section>

      {/* === Inline CSS === */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; line-height: 1.6; }

        /* Header */
        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 45vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }

        .page-title { font-size: 2.2rem; font-weight: bold; margin-bottom: 10px; }
        .intro-line { font-size: 1rem; margin-top: 5px; font-weight: 500; }

        /* Overview Section */
        .overview-section { padding: 40px 20px; max-width: 1400px; margin: auto; text-align: left; }
        .overview-content { margin-bottom: 40px; }
        .subtitle { font-size: 1rem; line-height: 1.6; margin-bottom: -80px; }

        /* Services Section */
        .content-section { padding: 40px 20px; max-width: 1200px; margin: auto; }
        .section-title { font-size: 1.5rem; color: #ff6600; margin-bottom: 25px; text-align: center; }

        .services-cards { display: flex; flex-wrap: wrap; gap: 20px; justify-content: center; }
        .service-card {
          flex: 1 1 300px;
          background: #f9f9f9;
          border: 2px solid #ff6600;
          border-radius: 12px;
          padding: 20px;
          text-align: center;
          transition: all 0.3s ease;
        }

        .service-card img {
          width: 100%;
          height: 300px;
          object-fit: cover;
          border-radius: 10px;
          margin-bottom: 15px;
        }

        .service-card h3 { margin-bottom: 10px; font-size: 1.2rem; color: #333; }
        .service-card p { font-size: 1rem; line-height: 1.5; }

        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.15);
        }

        /* Responsive */
        @media screen and (max-width: 768px) {
          .overlay { padding: 25px; }
          .page-title { font-size: 1.8rem; }
          .overview-section { padding: 30px 15px; }
          .content-section { padding: 30px 15px; }
          .services-cards { flex-direction: column; align-items: center; }
        }
      `}</style>
    </div>
  );
};

export default CalibrationServices;
